import supportModule from '../../support.module';
import template from './supportCaseHistoryTable.component.html';
import style from './supportCaseHistoryTable.component.css';

export default supportModule.component('supportCaseHistoryTable', {
    template: template,
    style: style,
    controller: controller
});

function controller(
    $state,
    accountProvider,
    asNotifier,
    stateConstants,
    supportCaseService,
    textResources,
    permissionService
) {
    var vm = this;
    var isInitialCount = true;
    vm.filteredItems = 0;
    vm.totalItems = 0;
    vm.hasSupportManagementPermissions = false;

    vm.getItems = criteria => {
        return supportCaseService
            .getCases(
                criteria.currentPage * criteria.itemsPerPage -
                    criteria.itemsPerPage,
                criteria.itemsPerPage + 1,
                vm.statusFilter,
                vm.ownerFilter
            )
            .then(
                data => {
                    data.items = data.items.slice(0, criteria.itemsPerPage);
                    data.totalItems = data.offset + data.size;
                    if (
                        isInitialCount ||
                        (vm.statusFilter == '' && vm.ownerFilter == '')
                    ) {
                        vm.totalItems = data.totalItems;
                    }
                    vm.filteredItems = data.totalItems;

                    vm.rangeStart = data.size == 0 ? 0 : data.offset + 1;
                    vm.rangeEnd = data.offset + data.items.length;
                    if (
                        criteria.sortBy &&
                        criteria.sortReverse !== undefined &&
                        data.items &&
                        data.items.length > 0
                    ) {
                        data.items = data.items.sort(
                            (prevCase, nextCase) =>
                                criteria.sortReverse
                                    ? nextCase[criteria.sortBy].localeCompare(
                                          prevCase[criteria.sortBy]
                                      )
                                    : prevCase[criteria.sortBy].localeCompare(
                                          nextCase[criteria.sortBy]
                                      )
                        );
                    }

                    return data;
                },
                data => {
                    if (!data) {
                        data = {
                            totalItems: 0
                        };
                    }
                    vm.totalItems = data.totalItems;
                    vm.filteredItems = data.totalItems;

                    vm.rangeStart = 0;
                    vm.rangeEnd = 0;
                    asNotifier.error(
                        `${textResources.genericError} ${
                            textResources.ifProblemPersists
                        }`
                    );

                    return data;
                }
            )
            .finally(() => {
                vm.showLoadingMask = false;
            });
    };

    vm.$onInit = () => {
        vm.initTable();
    };

    vm.initTable = () => {
        vm.showLoadingMask = true;
        vm.pagingOptions = {
            currentPage: 1,
            itemsPerPage: 20
        };
        vm.customClass = {
            hideTableMask: true
        };
        vm.tableOptions = {
            sortable: true,
            checkBox: 'none',
            paging: vm.pagingOptions,
            retrieveItemsAsync: vm.getItems,
            showHeaderWhenNoData: false,
            customClass: vm.customClass
        };

        accountProvider.isAccountOwner().then(isAccountOwner => {
            vm.isAccountOwner = isAccountOwner;
        });

        accountProvider.getUserGuid().then(userGuid => {
            permissionService
                .getPermissionsOfUser(userGuid, 'supportmanagement')
                .then(permissions => {
                    vm.hasSupportManagementPermissions = !permissions.notFound;
                });
        });

        supportCaseService.getCaseListConfig().then(
            data => {
                vm.tableOptions.columns = data.columns;

                if (!data || !data.filters) {
                    return;
                }

                if (data.filters.status) {
                    vm.dropdownStatusList = data.filters.status.values;

                    var defaultStatus = vm.dropdownStatusList.filter(
                        s => s.default == true
                    );
                    defaultStatus =
                        defaultStatus.length > 0
                            ? defaultStatus[0]
                            : vm.dropdownStatusList[0];
                    vm.statusFilter = defaultStatus.value;

                    vm.tableOptions.statusValues = vm.dropdownStatusList.reduce(
                        (obj, item) => {
                            obj[item.value] = item;
                            return obj;
                        },
                        {}
                    );
                }

                if (data.filters.owner) {
                    vm.dropdownOwnerList = data.filters.owner.values;

                    var defaultOwner = vm.dropdownOwnerList.filter(
                        s => s.default == true
                    );
                    defaultOwner =
                        defaultOwner.length > 0
                            ? defaultOwner[0]
                            : vm.dropdownOwnerList[0];
                    vm.ownerFilter = defaultOwner.value;
                }
            },
            () => {
                asNotifier.error(textResources.caseListConfigurationNotLoaded);
            }
        );
    };

    vm.onTableEditorReady = api => {
        vm.tableApi = api;
    };

    vm.onTableDataRendered = () => {
        vm.customClass.hideTableMask = false;
    };

    vm.changeStatusFilter = status => {
        vm.statusFilter = status;
        vm.reloadTable();
    };

    vm.changeOwnerFilter = owner => {
        vm.ownerFilter = owner;
        vm.reloadTable();
    };

    vm.reloadTable = () => {
        isInitialCount = false;
        vm.pagingOptions.currentPage = 1;
        vm.tableApi.reloadData();
    };

    vm.goToCreateCase = () => {
        $state.go(stateConstants.support.createcase.name);
    };
}



// WEBPACK FOOTER //
// ./modules/support/components/support-case-history-table/supportCaseHistoryTable.component.js